// extracted by mini-css-extract-plugin
export default {"loanDueDate":"loanDueDate---bYgJY","tooltipIcon":"tooltipIcon---clN8Y"};